import styled from 'styled-components'

const Wrapper = styled.div<{
	$enabled: boolean
}>`
	pointer-events: ${({ $enabled }) => ($enabled ? 'all' : 'none')};
	user-select: ${({ $enabled }) => ($enabled ? 'auto' : 'none')};
`

export default {
	Wrapper,
}
